// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__SRDuP","subheader":"ReorderModal_subheader__2hW5Y","listWrap":"ReorderModal_listWrap__3Af_y"};